// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/JobCategory.scss
// module id = ./src/styles/JobCategory.scss
// module chunks = 0